export function StethoscopeIcon() {
    return (
      <svg className="w-10 h-10 text-primary" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 4v5a4 4 0 004 4v3a5 5 0 0010 0v-3m-5 8v.01M20 12a2 2 0 11-4 0 2 2 0 014 0z" />
      </svg>
    );
  }
  
  export function PillBottleIcon() {
    return (
      <svg className="w-10 h-10 text-primary" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 2h6m-7 4h8M8 7h8a2 2 0 012 2v11a2 2 0 01-2 2H8a2 2 0 01-2-2V9a2 2 0 012-2zm2 5l4 4m0-4l-4 4" />
      </svg>
    );
  }
  
  export function CreditCardIcon() {
    return (
      <svg className="w-10 h-10 text-primary" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 7.5h19.5M2.25 10.5v7.125c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125V10.5m-19.5 0h19.5m-16.5 6h.008v.008H5.25V16.5z" />
      </svg>
    );
  }
  
  export function ShieldHeartIcon() {
    return (
      <svg className="w-10 h-10 text-primary" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 2l7 4v6c0 5-3 9-7 10-4-1-7-5-7-10V6l7-4zm0 7.5c.828 0 1.5.672 1.5 1.5S12.828 12.5 12 13.5c-.828-1-1.5-1.5-1.5-2.5S11.172 9.5 12 9.5z" />
      </svg>
    );
  }
  